import React, { useState, useEffect, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { createCustomerAdmin, fetchCassDetails } from "../../../store/Customeradmin/cutomeradminslice";
import { updatenotificationdata } from "../../../store/Common/CommonSlice";
import "./tablestyle.css";

export default function CustomerForm({pageType, setPageType}) {
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [allBranches, setAllBranches] = useState([]);
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();
  const branchids= localStorage.getItem("branch_name")

 console.log(branchids,"branchids")
  useEffect(() => {
    const parsedbranchids = JSON.parse(branchids).map(Number);
    console.log(parsedbranchids,"parsed")
    if(parsedbranchids){
    dispatch(fetchCassDetails({cass_ids:parsedbranchids}))
      .then((res) => {
        setAllBranches(res?.payload?.data?.data || []);
      })
      .catch((err) => console.error(err))
      .finally(() => setInitialLoading(false));}
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleBranch = (branch) => {
    setSelectedBranches(prev =>
      prev.some(b => b.id === branch.id)
        ? prev.filter(b => b.id !== branch.id)
        : [...prev, branch]
    );
  };

  const removeBranch = (id) => {
    setSelectedBranches(prev => prev.filter(b => b.id !== id));
  };

  const validationSchema = Yup.object({
    firstName: Yup.string()
      .matches(/^[A-Za-z\s]+$/, "First name cannot contain numbers or special characters")
      .required("First name is required")
      .min(2, "First Name must be at least 2 characters")
      .max(24, "First Name must be at most 24 characters"),
    lastName: Yup.string()
      .matches(/^[A-Za-z\s]+$/, "Last name cannot contain numbers or special characters")
      .required("Last name is required")
      .min(2, "Last Name must be at least 2 characters")
      .max(24, "Last Name must be at most 24 characters"),
    email: Yup.string().required('Email ID is required').email('Please enter your valid Email ID').matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, 'Invalid email address'),
    mobile: Yup.string().required("Phone Number is required").matches(/^\d{10}$/, "Phone no should be 0f 10 digits"),
    approvalStatus: Yup.string().required("Status is required"),
  });

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      approvalStatus: "",
    },
    validationSchema,
    onSubmit: (values) => {
      setLoading(true);
      dispatch(createCustomerAdmin({
        ...values,
        // branch_name: selectedBranches.map(b => b.id),
      }))
        .then((res) => {
          console.log("Form submitted successfully:", res);
          if (res?.payload?.statusCode === 200) {
            console.log("hi from err ,success", res?.payload?.statusCode);
            dispatch(updatenotificationdata(res?.payload));
            setPageType("table");
          } else {
            console.log("hi from err", res);
            dispatch(
              updatenotificationdata(
                res?.payload?.success
                  ? res.payload
                  : {
                      success: "error",
                      message:
                        res?.payload?.message ||
                        "Something went wrong while creating the user. Please try again.",
                    }
              )
            );
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          console.error("Error submitting form:", err);
          dispatch(
            updatenotificationdata({
              success: "error",
              message:
                err?.data?.message ||
                err?.message ||
                "Something went wrong while creating the user. Please try again.",
            })
          );
        });
    },
  });

  const handlecancel = () => {
    console.log("handlecancel");
    setPageType("table");
  };

  return (
    <div className="w-full max-w-2xl mx-auto bg-white p-6">
      {initialLoading ? (
        <div className="flex items-center w-full h-full justify-center">
          <span className="loader"></span>
        </div>
      ) : (
        <div className="w-full max-w-2xl mx-auto bg-white shadow-lg rounded-lg p-6">
          <h2 className="text-2xl font-bold mb-4">Create User</h2>
          <form onSubmit={formik.handleSubmit} className="space-y-6">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">
                  First Name
                </label>
                <input
                  id="firstName"
                  name="firstName"
                  type="text"
                  value={formik.values.firstName}
                  onChange={(e) => { if (e.target.value.length <= 24) { formik.handleChange(e); } }}
                  onBlur={formik.handleBlur}
                  className="mt-1 block w-full p-2 rounded-md border-black border-2 shadow-sm text-sm"
                  placeholder="Enter first name"
                />
                {formik.touched.firstName && formik.errors.firstName && (
                  <p className="text-sm text-red-500">{formik.errors.firstName}</p>
                )}
              </div>
              <div>
                <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">
                  Last Name
                </label>
                <input
                  id="lastName"
                  name="lastName"
                  type="text"
                  value={formik.values.lastName}
                  onChange={(e) => { if (e.target.value.length <= 24) { formik.handleChange(e); } }}
                  onBlur={formik.handleBlur}
                  className="mt-1 block w-full rounded-md p-2 border-black border-2 shadow-sm text-sm"
                  placeholder="Enter last name"
                />
                {formik.touched.lastName && formik.errors.lastName && (
                  <p className="text-sm text-red-500">{formik.errors.lastName}</p>
                )}
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="mt-1 block w-full rounded-md p-2 shadow-sm border-black border-2 text-sm"
                  placeholder="Enter email address"
                />
                {formik.touched.email && formik.errors.email && (
                  <p className="text-sm text-red-500">{formik.errors.email}</p>
                )}
              </div>
              <div>
                <label htmlFor="mobile" className="block text-sm font-medium text-gray-700">
                  Mobile Number
                </label>
                <input
                  id="mobile"
                  name="mobile"
                  type="number"
                  value={formik.values.mobile}
                  onChange={(e) => { if (e.target.value.length <= 10) { formik.handleChange(e); } }}
                  onBlur={formik.handleBlur}
                  className="mt-1 block w-full rounded-md p-2 shadow-sm border-black border-2 text-sm"
                  placeholder="Enter mobile number"
                />
                {formik.touched.mobile && formik.errors.mobile && (
                  <p className="text-sm text-red-500">{formik.errors.mobile}</p>
                )}
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label htmlFor="approvalStatus" className="block text-sm font-medium text-gray-700">
                  Status
                </label>
                <select
                  id="approvalStatus"
                  name="approvalStatus"
                  value={formik.values.approvalStatus}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="mt-1 block w-full rounded-md p-2 shadow-sm border-black border-2 text-sm"
                >
                  <option value="" disabled>Select status</option>
                  <option value="approved">Approved</option>
                  <option value="pending">Pending</option>
                </select>
                {formik.touched.approvalStatus && formik.errors.approvalStatus && (
                  <p className="text-sm text-red-500">{formik.errors.approvalStatus}</p>
                )}
              </div>
               {/* Branch multi-select */}
            {/* <div>
              <label className="block text-sm font-medium text-gray-700">Branches</label>
              <div className="relative mt-1" ref={dropdownRef}>
                <div
                  className="min-h-[42px] w-full rounded-md border-2 border-black p-2 flex flex-wrap gap-1 cursor-pointer"
                  onClick={() => setDropdownOpen(o => !o)}
                >
                  {selectedBranches.length === 0 && (
                    <span className="text-gray-400 text-sm">Select branches...</span>
                  )}
                  {selectedBranches.map(b => (
                    <span
                      key={b.id}
                      className="flex items-center gap-1 bg-yellow-100 border border-yellow-400 rounded px-2 py-0.5 text-xs font-medium"
                    >
                      {b.branch_name}
                      <button
                        type="button"
                        className="text-gray-500 hover:text-red-500 leading-none ml-1"
                        onClick={(e) => { e.stopPropagation(); removeBranch(b.id); }}
                      >
                        ×
                      </button>
                    </span>
                  ))}
                </div>
                {dropdownOpen && (
                  <div className="absolute z-20 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-48 overflow-y-auto mt-1">
                    {allBranches.length === 0 ? (
                      <div className="p-3 text-sm text-gray-500 text-center">Loading branches...</div>
                    ) : (
                      allBranches.map(b => (
                        <label
                          key={b.id}
                          className={`flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-50 ${
                            selectedBranches.some(s => s.id === b.id) ? 'bg-blue-50' : ''
                          }`}
                        >
                          <input
                            type="checkbox"
                            checked={selectedBranches.some(s => s.id === b.id)}
                            onChange={() => toggleBranch(b)}
                            className="w-4 h-4 accent-yellow-500"
                          />
                          <span className="text-sm">{b.branch_name}</span>
                        </label>
                      ))
                    )}
                  </div>
                )}
              </div> */}
            {/* </div> */}
            </div>

           

            <div className="flex justify-end space-x-4">
              <button
                type="button"
                className="bg-black text-white hover:bg-yellow-500 font-bold py-2 px-4 rounded-md hover:text-white"
                onClick={handlecancel}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                className="bg-yellow-500 text-white hover:bg-black font-bold py-2 px-4 rounded-md hover:text-white disabled:opacity-70 disabled:cursor-not-allowed flex items-center gap-2"
              >
                {loading && (
                  <span className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
                )}
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
